<template>
    <mds-layout-grid :class="namespaceClass()">
        <mds-row>
            <mds-col>
                <div :class="namespaceClass('__subtitle')">
                    {{ this.getUILabel("report_generator_title") }}
                </div>
                <report-list-view
                    mwc-id="report-list-view"
                    :class="namespaceClass('__report-list')"
                    :report-items="this.$store.getters['reportSetting/reportOptionsModel']"
                ></report-list-view>
                <div v-if="isLoadingReport" :class="namespaceClass('__loader-overlay')">
                    <mds-loader :class="namespaceClass('__loader')"></mds-loader>
                </div>
            </mds-col>
        </mds-row>
    </mds-layout-grid>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import ReportListView from "./ReportListView";
import { openNewTab, showPDF, isMSIEOrEdgeBrowser, showPDFInIE } from "@/util";
import MdsLoader from "@mds/loader";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid";

export default {
    name: "report-generator",
    components: {
        ReportListView,
        MdsLoader,
        MdsLayoutGrid,
        MdsRow,
        MdsCol
    },
    mixins: [HypoVueBaseMixin, MwcSharedMixin],
    data() {
        return {
            isLoadingReport: false,
            defaultConfig: {
                labels: this.$store.state.labels.labels
            }
        };
    },
    mounted() {
        this.$store.dispatch("reportSetting/getStateList", { fetch: this.$fetch });
    },
    methods: {
        handleGenerateReport(e) {
            const isMSIEOrEdge = isMSIEOrEdgeBrowser();
            let tab;
            if (isMSIEOrEdge) {
                this.isLoadingReport = true;
            } else {
                tab = openNewTab();
            }
            this.$store.dispatch("reportSetting/generatePDFReport", { fetch: this.$fetch }).then(data => {
                if (isMSIEOrEdge) {
                    this.isLoadingReport = false;
                    showPDFInIE(data);
                } else {
                    showPDF(tab, data);
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~@mds/typography";
.report-generator {
    margin: 0px 116px;

    &__subtitle {
        @include mds-level-6-heading($bold: false);
        color: $mds-color-neutral-12;
        margin-top: 11px;
        margin-bottom: 19px;
    }

    &__report-list {
        margin-top: 16px;
    }

    &__action {
        display: flex;
        justify-content: flex-end;
        margin-top: 48px;
        margin-bottom: 64px;
        .mds-button {
            height: 40px;
            margin-left: 16px;
            font-size: $mds-typography-font-size-l;
        }
    }

    &__loader-overlay {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        pointer-events: "none";
    }

    &__loader {
        top: 50%;
        transform: translateY(-50%);
    }
}
</style>
